/* eslint-disable */

export default [
  // Main
  {
    path: '/',
    name: 'developers',
    component: () => import('@views/Developers'),
  },
  {
    path: '/welcome',
    name: 'developers-welcome',
    component: () => import('@views/Developers'),
    meta: {
      welcome: true,
    },
  },
  {
    path: '/about/promo',
    name: 'promo',
    component: () => import('@views/Promo'),
  },
  {
    path: '/about',
    name: 'about',
    beforeEnter: (to, from, next) => {
        const isFromGameCenter = to.query.from === 'gamecenter';

        if (!isFromGameCenter) {
          next('/about/promo');
        } else {
          next()
        }
    },
    component: () => import('@views/About'),
  },
  {
    path: '*',
    name: 'not-found',
    component: () => import('@views/NotFound'),
  }
];
